import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { IMadlibOptions } from '../../shared/services/mad-lib-services/mad-lib-helpers';
import * as madlibOptionsActions from '../actions/madlib-options-actions';
import { ApiService } from './../../shared/services/api-service/api-service';

interface IAction {
  type: string;
  payload: {
    paths: string;
    schoolId: string;
  };
}

@Injectable()
export class MadlibOptionsEffects {
  constructor(private actions$: Actions, private apiService: ApiService, private store$: Store<any>) {}

  @Effect()
  loadMadlibOptions$ = this.actions$.pipe(
    ofType(madlibOptionsActions.LOAD_MADLIB_OPTIONS),
    switchMap((action: IAction) => {
      const { schoolId, paths } = action.payload;
      return this.apiService.getMadlibOptions(schoolId, paths).pipe(
        mergeMap((madlibOptions: IMadlibOptions) => {
          return [new madlibOptionsActions.LoadMadlibOptionsSuccess(madlibOptions)];
        }),
        catchError(error => {
          return of(new madlibOptionsActions.LoadMadlibOptionsFail(error));
        }),
      );
    }),
  );
}
